/* src/pages/CloudServices.js */

import React from "react";
import PageSection from "../components/PageSection";
import { Helmet } from "react-helmet";
import styles from "./Pages.module.css"; // CSS Module
import cloudServicesImage from "../assets/Images/cloud-services.jpg";

function CloudServices() {
  const faqs = [
    {
      question: "What does 'moving to the cloud' actually mean?",
      answer:
        "It means your files, email, or software live on the internet instead of just on your office computers. You can access them from anywhere, they're backed up automatically, and you don't have to worry about your server dying.",
    },
    {
      question: "Is the cloud actually secure?",
      answer:
        "When set up right, yes. I use encryption and proper security settings to keep your data safe. It's often MORE secure than keeping everything on an old office server with no backup.",
    },
    {
      question: "Will it save me money?",
      answer:
        "Usually, yes - especially if you're paying to maintain old servers or worried about losing data. You pay a monthly fee instead of big upfront costs, and you only pay for what you use.",
    },
  ];

  return (
    <PageSection title="Cloud Services" cta faqs={faqs}>
      <Helmet>
        <title>Cloud Services | Tharpe Industries</title>
        <meta
          name="description"
          content="Scalable and secure cloud solutions to enhance your business operations. Expert cloud integration and support to drive efficiency and collaboration."
        />
      </Helmet>
      <div className={styles.contentContainerReverse}>
        <img
          src={cloudServicesImage}
          alt="Cloud Services"
          className={styles.pageImage}
          loading="lazy"
        />
        <div className={styles.textContent}>
          <p>
            Tired of worrying about your office server dying and taking all your data with it? Want to work from 
            home or access files from anywhere? Moving to the cloud might make sense for you.
          </p>
          <p>
            I help local businesses move their files, email, and software to the cloud - whether that's Microsoft 365, 
            Google Workspace, or something else. I'll help you figure out what makes sense for your budget and needs, 
            then set it up so it actually works. No tech jargon, just practical solutions.
          </p>
        </div>
      </div>
    </PageSection>
  );
}

export default CloudServices;
